import React, { useState, useEffect, useCallback, useRef } from "react";
import Flag from 'react-country-flag'; // npm install react-country-flag
 const API_URL = 'https://api.securxperts.com:8000';
  const ENDPOINT = '/forms/hms';
   const ContactForm = () => {
      const [form, setForm] = useState({
        name: '',
        email: '',
        country_code: '',
        phoneno: '',
        purpose: '',
        branch_type: '',
        type_of: '',
        services: '',
        no_of_beds: '',
        total_logins: '',
        product_taking_time: '',
        heard_from: '',
      });
  useEffect(() => {
    console.log("ContactForm mounted");
    return () => console.log("ContactForm unmounted");
  }, []);
  
      const [errors, setErrors] = useState({});
      const [submitting, setSubmitting] = useState(false);
      const [showSuccessPopup, setShowSuccessPopup] = useState(false);
      const [isCountryOpen, setIsCountryOpen] = useState(false);
      const [countrySearch, setCountrySearch] = useState('');
      const dropdownRef = useRef(null);
  
      // Input filters
      const nameFilter = useCallback((value) => /^[A-Za-z\s]*$/.test(value) ? value.slice(0, 50) : form.name, [form.name]);
      const phoneFilter = useCallback((value) => /^\d*$/.test(value) ? value.slice(0, 10) : form.phoneno, [form.phoneno]);
      const bedsFilter = useCallback((value) => /^\d*$/.test(value) ? value.slice(0, 4) : form.no_of_beds, [form.no_of_beds]);
      const loginsFilter = useCallback((value) => /^\d*$/.test(value) ? value.slice(0, 4) : form.total_logins, [form.total_logins]);
  
      // COUNTRIES WITH FLAGS
      const countries = [
        { code: '+91', iso: 'IN', name: 'India' },
        { code: '+1', iso: 'US', name: 'United States' },
        { code: '+44', iso: 'GB', name: 'United Kingdom' },
        { code: '+971', iso: 'AE', name: 'United Arab Emirates' },
        { code: '+61', iso: 'AU', name: 'Australia' },
        { code: '+852', iso: 'HK', name: 'Hong Kong' },
        { code: '+36', iso: 'HU', name: 'Hungary' },
        { code: '+354', iso: 'IS', name: 'Iceland' },
        { code: '+93', iso: 'AF', name: 'Afghanistan' },
        { code: '+355', iso: 'AL', name: 'Albania' },
      ];
  
      const filteredCountries = countries.filter(country =>
        country.name.toLowerCase().includes(countrySearch.toLowerCase()) ||
        country.code.toLowerCase().includes(countrySearch.toLowerCase())
      );
  
      const validateField = (name, value) => {
        switch (name) {
          case 'name':
            if (!value.trim()) return 'Please enter your full name';
            if (!/^[A-Za-z\s]+$/.test(value)) return 'Name can only contain letters and spaces';
            return '';
  
          case 'email':
            if (!value.trim()) return 'Email is required';
            if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) return 'Please enter a valid email address';
            return '';
  
          case 'country_code':
            if (!value.trim()) return 'Country code is required';
            if (!countries.some(c => c.code === value)) return 'Select valid country code from dropdown';
            return '';
  
          case 'phoneno':
            if (!value.trim()) return 'Phone number is required';
            if (!/^\d+$/.test(value)) return 'Phone number must contain only digits';
            if (value.length !== 10) return 'Phone number must be exactly 10 digits';
            return '';
  
          case 'purpose':
            if (!value.trim()) return 'Please specify purpose (Demo/Purchase/Upgrade)';
            return '';
  
          case 'branch_type':
            if (!value.trim()) return 'Please specify branch type';
            return '';
  
          case 'type_of':
            if (!value.trim()) return 'Please specify type of hospital';
            return '';
  
          case 'services':
            if (!value.trim()) return 'Please list your key services';
            return '';
  
          case 'no_of_beds':
            if (!value.trim()) return 'Please enter number of beds';
            const beds = parseInt(value);
            if (isNaN(beds) || beds < 1 || beds > 5000) return 'Enter valid number of beds (1-5000)';
            return '';
  
          case 'total_logins':
            if (!value.trim()) return 'Please enter total logins/users';
            const logins = parseInt(value);
            if (isNaN(logins) || logins < 1 || logins > 10000) return 'Enter valid number of users (1-10000)';
            return '';
  
          case 'product_taking_time':
            if (!value.trim()) return 'Please tell us when you plan to start using HMS';
            if (!/\d/.test(value)) return 'Time must include numbers (e.g., 8 pm)';
            if (!/[a-zA-Z]/.test(value)) return 'Time must include letters (e.g., am/pm)';
            return '';
  
          case 'heard_from':
            if (!value.trim()) return 'Please tell us how you heard about us';
            return '';
  
          default:
            return '';
        }
      };
  
      const handleChange = (e) => {
        const { name, value } = e.target;
        let filteredValue = value;
  
        // Apply filters
        switch (name) {
          case 'name': filteredValue = nameFilter(value); break;
          case 'phoneno': filteredValue = phoneFilter(value); break;
          case 'no_of_beds': filteredValue = bedsFilter(value); break;
          case 'total_logins': filteredValue = loginsFilter(value); break;
          case 'product_taking_time': 
            // Time fields - allow any characters with maxLength 8
            // No validation - allow any characters
            break;
        }
  
        setForm(prev => ({ ...prev, [name]: filteredValue }));
        const errorMsg = validateField(name, filteredValue);
        setErrors(prev => ({ ...prev, [name]: errorMsg }));
      };
  
      // Country selection
      const selectCountry = (code) => {
        setForm(prev => ({ ...prev, country_code: code }));
        setIsCountryOpen(false);
        setCountrySearch('');
        setErrors(prev => ({ ...prev, country_code: '' }));
      };
  
      // Outside click handler
     useEffect(() => {
  const handlePointerDown = (event) => {
    if (!dropdownRef.current) return;

    // Ignore scrollbar interactions
    if (event.pointerType === "mouse" && event.buttons === 0) return;

    if (!dropdownRef.current.contains(event.target)) {
      setIsCountryOpen(false);
    }
  };

  document.addEventListener("pointerdown", handlePointerDown);

  return () => {
    document.removeEventListener("pointerdown", handlePointerDown);
  };
}, []);

  
      const validateAll = () => {
        const newErrors = {};
        Object.keys(form).forEach(key => {
          newErrors[key] = validateField(key, form[key]);
        });
        setErrors(newErrors);
        return Object.values(newErrors).every(err => err === '');
      };
  
      const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateAll()) return;
  
        setSubmitting(true);
        try {
          const payload = { ...form };
          const resp = await fetch(`${API_URL}${ENDPOINT}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          });
  
          if (resp.ok) {
            setShowSuccessPopup(true);
            setForm({
              name: '', email: '', country_code: '', phoneno: '',
              purpose: '', branch_type: '', type_of: '', services: '',
              no_of_beds: '', total_logins: '', product_taking_time: '', heard_from: '',
            });
            setErrors({});
          } else {
            console.error('HMS submit failed:', resp.status);
          }
        } catch (error) {
          console.error('HMS submit error:', error);
        } finally {
          setSubmitting(false);
        }
      };
  
      useEffect(() => {
        if (showSuccessPopup) {
          const timer = setTimeout(() => setShowSuccessPopup(false), 5000);
          return () => clearTimeout(timer);
        }
      }, [showSuccessPopup]);
  
      // COMPACT SUCCESS POPUP
      const hasAnyError = Object.values(errors).some(e => e);
  
  return (
    <>
      {/* SUCCESS POPUP */}
      {showSuccessPopup && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl p-8 max-w-sm w-full shadow-2xl relative animate-in fade-in zoom-in duration-200">
            <button
              onClick={() => setShowSuccessPopup(false)}
              className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 text-2xl"
            >
              ×
            </button>
            <div className="text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2 text-green-600">Success!</h3>
              <p className="text-gray-600">Your HMS enquiry has been Submitted Successfully.</p>
            </div>
          </div>
        </div>
      )}
  
  
     
  
     {/* FORM */}
     <form
    onSubmit={handleSubmit}
    onClick={(e) => e.stopPropagation()}
    onMouseDown={(e) => e.stopPropagation()}
  >
  
          <h3 className="text-2xl md:text-3xl font-bold text-center mb-6 text-white">
            Hospital Management System – Enquiry Form
          </h3>
  
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {[
              { name: 'name', placeholder: 'Full Name *', span: 1 },
              { name: 'email', type: 'email', placeholder: 'Email *', span: 1 },
              
              // COUNTRY DROPDOWN
              { name: 'country_code', placeholder: 'Country Code *', span: 1, isDropdown: true },
              
              { name: 'phoneno', placeholder: 'Phone Number *', span: 1 },
              { name: 'purpose', placeholder: 'Purpose (Demo/Purchase/Upgrade) *', span: 2 },
              { name: 'branch_type', placeholder: 'Branch Type *', span: 2 },
              { name: 'type_of', placeholder: 'Type of Hospital *', span: 2 },
              { name: 'services', placeholder: 'Key Services *', span: 2 },
              { name: 'no_of_beds', type: 'number', placeholder: 'No. of Beds *', span: 1 },
              { name: 'total_logins', type: 'number', placeholder: 'Total Logins *', span: 1 },
              { name: 'product_taking_time', placeholder: 'When do you plan to start? *', span: 2, maxLength: 8 },
              { name: 'heard_from', placeholder: 'How did you hear about us? *', span: 2 },
            ].map((field) => (
              <div key={field.name} className={`${field.span === 2 ? 'md:col-span-2' : ''}`}>
                {field.isDropdown ? (
                  // COUNTRY DROPDOWN WITH FLAGS
                  <div className="relative" ref={dropdownRef}>
                   <button
    type="button"
    onClick={() => setIsCountryOpen(prev => !prev)}
    className={`w-full px-4 py-3 rounded-lg border-2 border-white/20 bg-white/10
      text-white text-left flex justify-between items-center`}
  >
    <span>
      {form.country_code || 'Select Country Code'}
    </span>
    <svg className="w-5 h-5" viewBox="0 0 24 24">
      <path d="M19 9l-7 7-7-7" />
    </svg>
  </button>
  
                    {errors.country_code && (
                      <p className="mt-1 text-xs text-orange-400 font-medium pl-2">{errors.country_code}</p>
                    )}
  
                    {isCountryOpen && (
                      <div className="absolute z-50 w-full mt-1 bg-white/95 border border-white/20 rounded-xl shadow-2xl max-h-80 overflow-hidden backdrop-blur-sm">
                        <input
                          type="text"
                          value={countrySearch}
                          onChange={(e) => setCountrySearch(e.target.value)}
                          placeholder="Search country or code..."
                          className="w-full px-4 py-3 border-b border-gray-100 text-sm focus:outline-none focus:ring-1 focus:ring-[#2c75ff] bg-white"
                          autoFocus
                        />
                        <div className="max-h-64 overflow-auto">
                          {filteredCountries.length > 0 ? (
                            filteredCountries.map((country) => (
                              <button
                                key={country.code}
                                type="button"
                                onClick={() => selectCountry(country.code)}
                                className="w-full px-4 py-3 text-left hover:bg-[#2c75ff]/10 transition-all flex items-center gap-3 text-sm first:pt-2 last:pb-2 focus:outline-none focus:bg-[#2c75ff]/20"
                              >
                                <Flag countryCode={country.iso} svg className="w-6 h-4 flex-shrink-0 rounded" />
                                <span className="font-medium flex-1 min-w-0 truncate pr-4">{country.name}</span>
                                <span className="text-xs font-mono text-gray-700 bg-gray-100 px-2 py-1 rounded-full">
                                  {country.code}
                                </span>
                              </button>
                            ))
                          ) : (
                            <div className="px-4 py-8 text-center text-sm text-gray-500">No countries found</div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  // REGULAR INPUT
                  <>
                    <input
                      name={field.name}
                      type={field.type || 'text'}
                      value={form[field.name]}
                      onChange={handleChange}
                      placeholder={field.placeholder}
                      maxLength={field.maxLength || undefined}
                      required
                      className={`w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none transition-all border-2 border-white/20 hover:border-white/40 focus:border-[#2c75ff] focus:ring-1 focus:ring-[#2c75ff]/30 ${
                        errors[field.name] ? 'border-orange-400 ring-2 ring-orange-200/50' : ''
                      }`}
                    />
                    {errors[field.name] && (
                      <p className="text-orange-400 text-xs mt-1 pl-1">{errors[field.name]}</p>
                    )}
                  </>
                )}
              </div>
            ))}
          </div>
  
         <button
  type="submit"
  disabled={submitting || hasAnyError}
  className={`w-full mt-6 py-3 rounded-xl font-semibold text-white transition-all
    ${submitting || hasAnyError
      ? "bg-gray-400 cursor-not-allowed"
      : "bg-[#2c75ff] hover:bg-[#1f5fe0]"}
  `}
>
  {submitting ? "Submitting..." : "Submit Enquiry"}
</button>

  
          <p className="text-xs mt-4 text-white/60 text-center">
            Your details will remain confidential and used only for enquiry purposes.
          </p>
       </form>
    </>
  );
  }; 
  
  export default React.memo(ContactForm);